import { defineMessages } from 'react-intl-next';

export const messages: {
	openDmButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	openDmButtonLabel: {
		id: 'search-page.social-signals.user-card.open-dm-button-label',
		defaultMessage: 'Direct message',
		description:
			'Tooltip and a11y label to let the user know they can DM the user in the card by interacting with the external messaging service button',
	},
});
